// src/services/dashboard.service.js
import axios from "../utils/axios.wrapper";

export const getDashboard = async ({ shopId = null, startDate, endDate, preset }) => {
  const { data } = await axios.post("/dashboard", {
    shopId,
    startDate,
    endDate,
    preset, // "today" | "week" | "month" | "year" | "custom"
  });
  // Backend renvoie directement le DTO du dashboard
  return data;
};

export const dashboardService = {
  getDashboard,
};
